export default __webpack_public_path__ + "static/media/specs-3.583f40c1.png";